module.exports = __webpack_public_path__ + "static/media/team-jimmy.1b17df59.png";